import { render } from "./PermissionForm.vue?vue&type=template&id=17244d1b"
import script from "./PermissionForm.vue?vue&type=script&lang=js"
export * from "./PermissionForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__